import { defineComponent as P, ref as l, provide as V, computed as p, watch as N, onMounted as Y, onUnmounted as O, openBlock as i, createElementBlock as m, normalizeClass as f, createBlock as W, createCommentVNode as s, createElementVNode as g, createVNode as $, withCtx as B, renderSlot as j, normalizeStyle as h, toDisplayString as z } from "vue";
import S from "./Container.js";
import G from "./AnchorLine.js";
import { pageBottomContextKey as H } from "./PageBottomContext.ts.js";
import { _ as L } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/PageBottom.css';const M = ["data-visible", "data-fully-visible"], U = ["data-claim-visible"], q = { class: "page-bottom-claim-text" }, D = /* @__PURE__ */ P({
  __name: "PageBottom",
  props: {
    /**
     * The URL or Cloudinary path of the background image.
     * If cloudinary path (starts with /), will apply cloudinary transforms.
     */
    imgTmp: {
      type: String
    },
    /**
     * Cloudinary crop height in pixels.
     * Used when imgTmp is a cloudinary path.
     *
     * @default 400
     */
    imgTmpHeight: {
      type: Number,
      default: 400
    },
    /**
     * Cloudinary gravity for image crop.
     * 'south' shows the bottom of the image (e.g., feet).
     *
     * @default 'south'
     */
    imgTmpGravity: {
      type: String,
      default: "south"
    },
    /**
     * Defines the horizontal placement of the background image.
     *
     * @default 'center'
     */
    imgTmpAlignX: {
      type: String,
      default: "center"
    },
    /**
     * Defines the vertical placement of the background image.
     *
     * @default 'bottom'
     */
    imgTmpAlignY: {
      type: String,
      default: "bottom"
    },
    /**
     * The CSS background of the overlay on top of the cover image/bg.
     */
    overlay: {
      type: String
    },
    /**
     * Anchor line at top of page-bottom.
     * - false: no anchor line
     * - true: anchor line with 'accent' variant (default)
     * - 'accent' | 'primary' | 'default' | 'muted': specific variant
     *
     * @default true
     */
    anchorline: {
      type: [Boolean, String],
      default: !0
    },
    /**
     * The anchor ID for the anchorline element.
     * Used for scroll-to navigation.
     *
     * @default 'pagebottom'
     */
    anchor: {
      type: String,
      default: "pagebottom"
    },
    /**
     * Background effect mode.
     * - 'appear': Image fades in as user scrolls (default)
     * - 'uncover': Image sits behind entire PageBottom, effect div is translucent
     * - 'scroll': Image scrolls with parallax effect
     *
     * @default 'appear'
     */
    effect: {
      type: String,
      default: "appear"
    },
    /**
     * Defines the width of the slot content.
     *
     * @default 'full'
     */
    contentWidth: {
      type: String,
      default: "full"
    },
    /**
     * Claim configuration for text at bottom of effect area.
     * - text: The claim text to display
     * - orientation: 'left' | 'right' (default: 'left')
     * - effect: 'fade' | 'slide' | 'typewriter' (default: 'fade')
     */
    claim: {
      type: Object
    }
  },
  setup(e) {
    const t = e, n = l(!1);
    V(H, {
      interaction: n,
      setInteraction: (a) => {
        n.value = a;
      },
      anchor: t.anchor
    });
    const A = l(null), x = l(null), y = l(null), d = l(!1), v = l(!1), b = l(!1), C = p(() => t.anchorline !== !1), E = p(() => t.anchorline === !0 ? "accent" : t.anchorline === !1 ? "invisible" : t.anchorline), X = p(() => t.effect !== "uncover" ? t.imgTmpAlignX : t.imgTmpAlignX === "center" ? "calc(50% + var(--sidebar-width, 0px) / 2)" : t.imgTmpAlignX), T = p(() => {
      if (!t.imgTmp) return;
      if (t.imgTmp.startsWith("http"))
        return t.imgTmp;
      const a = "https://res.cloudinary.com/dasei/image/upload", c = [
        "c_fill",
        "w_1920",
        `h_${t.imgTmpHeight}`,
        `g_${t.imgTmpGravity}`,
        "q_auto",
        "f_auto"
      ].join(","), o = t.imgTmp.startsWith("/") ? t.imgTmp.slice(1) : t.imgTmp;
      return `${a}/${c}/v1/${o}`;
    });
    let u = null;
    const k = () => {
      if (!y.value) return;
      const a = t.effect === "appear" ? [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] : [0, 0.1, 0.5, 0.9];
      u = new IntersectionObserver(
        (c) => {
          const o = c[0];
          if (!o) return;
          const r = o.intersectionRatio;
          t.effect === "appear" ? (d.value = r >= 0.5, v.value = r >= 0.8, b.value = r >= 0.9) : (d.value = r > 0.1, v.value = r >= 0.5, b.value = r >= 0.5);
        },
        { threshold: a }
      ), u.observe(y.value);
    }, w = () => {
      u && (u.disconnect(), u = null);
    };
    N(n, (a) => {
      a ? (w(), d.value = !1, v.value = !1, b.value = !1) : setTimeout(() => {
        k();
      }, 100);
    });
    const I = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    return Y(() => {
      k();
    }), O(() => {
      w();
    }), (a, c) => {
      var o;
      return i(), m("div", {
        ref_key: "pageBottomEl",
        ref: A,
        class: f(["page-bottom", [
          `page-bottom-effect-${e.effect}`,
          { "page-bottom-interaction": n.value }
        ]])
      }, [
        C.value ? (i(), W(G, {
          key: 0,
          anchor: e.anchor,
          variant: E.value,
          sticky: !n.value,
          class: "page-bottom-anchorline"
        }, null, 8, ["anchor", "variant", "sticky"])) : s("", !0),
        g("div", {
          ref_key: "slotEl",
          ref: x,
          class: f(["page-bottom-slot", [`page-bottom-slot-${e.contentWidth}`]])
        }, [
          $(S, null, {
            default: B(() => [
              j(a.$slots, "default", {}, void 0, !0)
            ]),
            _: 3
          })
        ], 2),
        !n.value && (e.imgTmp || e.claim) ? (i(), m("div", {
          key: 1,
          ref_key: "effectEl",
          ref: y,
          class: f(["page-bottom-effect", { "page-bottom-effect-has-image": !!e.imgTmp }]),
          style: h(e.effect === "uncover" && e.imgTmp ? {
            backgroundImage: `url(${T.value})`,
            backgroundPositionX: X.value,
            backgroundPositionY: e.imgTmpAlignY
          } : void 0),
          "data-visible": d.value,
          "data-fully-visible": v.value
        }, [
          e.effect === "appear" && e.imgTmp ? (i(), m("div", {
            key: 0,
            class: "page-bottom-effect-image",
            style: h({
              backgroundImage: `url(${T.value})`,
              backgroundPositionX: e.imgTmpAlignX,
              backgroundPositionY: e.imgTmpAlignY
            })
          }, [
            e.overlay ? (i(), m("div", {
              key: 0,
              class: "page-bottom-effect-overlay",
              style: h({ background: e.overlay })
            }, null, 4)) : s("", !0)
          ], 4)) : s("", !0),
          e.effect === "uncover" && e.overlay ? (i(), m("div", {
            key: 1,
            class: "page-bottom-effect-overlay",
            style: h({ background: e.overlay })
          }, null, 4)) : s("", !0),
          e.claim ? (i(), m("div", {
            key: 2,
            class: f(["page-bottom-claim", [
              `page-bottom-claim-${e.claim.orientation || "left"}`,
              `page-bottom-claim-effect-${e.claim.effect || "fade"}`,
              e.claim.light ? "page-bottom-claim-light" : "page-bottom-claim-dark"
            ]]),
            "data-claim-visible": b.value
          }, [
            $(S, null, {
              default: B(() => [
                g("p", q, z(e.claim.text), 1)
              ]),
              _: 1
            })
          ], 10, U)) : s("", !0),
          g("button", {
            class: f(["page-bottom-scroll-top", [`page-bottom-scroll-top-${((o = e.claim) == null ? void 0 : o.orientation) || "left"}`]]),
            "aria-label": "Nach oben scrollen",
            onClick: I
          }, [...c[0] || (c[0] = [
            g("svg", {
              fill: "currentColor",
              height: "32",
              viewBox: "0 0 256 256",
              width: "32",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              g("path", { d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z" })
            ], -1)
          ])], 2)
        ], 14, M)) : s("", !0)
      ], 2);
    };
  }
}), _ = /* @__PURE__ */ L(D, [["__scopeId", "data-v-71e425b1"]]);
export {
  _ as default
};
